import { Injectable } from '@angular/core';
import { B2cConfig } from '../models/b2cConfig';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import moment from 'moment-timezone';
import { DatastoreService } from "./datastore.service";
import { ApiService } from './jrni/api.service';
import { AvailabilityService } from './jrni/availability.service';
import { inject } from '@angular/core';
import { Buffer } from 'buffer';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { ExtendedJwtPayload } from '../models/ExtendedJwtPayload.model';

@Injectable({
  providedIn: 'root'
})
export class B2cService {

  clientId: string;
  host: string;
  policy: string;
  nonce:string;
  currentState: URLSearchParams;
  token: string;
  decodedToken: ExtendedJwtPayload;
  verified: boolean;
  ceremonyDateId: number;
	date: string;
	ceremonyDate: any;
	// fees: any = [];
	totalCost: any;
	daysAway = 0;
	costTotal = 0;
	depositTotal = 0;
  company: any;
  service: any;

  dataStore: DatastoreService = inject(DatastoreService);
  apiService: ApiService = inject(ApiService);
  availabilityService: AvailabilityService = inject(AvailabilityService);
  constructor() { }

  set(data: B2cConfig) {
    this.clientId = data.clientId;
    this.host = data.host;
    this.policy = data.policy;
    if (!this.nonce) {
      this.generateNonce();
    }
  }

  private generateNonce() {
    const time = moment().tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss');
    console.log(this.dataStore.config);
    if (this.dataStore.config.hasOwnProperty('journey_config')) {
      if (this.dataStore.config.journey_config.hasOwnProperty('ceremonies')) {
        const appName = 'ceremonies';
        this.nonce = `${appName}-${time}`;
      }
      else {
        this.nonce = 'defaultNonce';
      }
    }
    else {
      this.nonce = 'defaultNonce';
    }
    console.log("Nonce set to ", this.nonce);
    return this;
  }

  private generateState(companyId: number, serviceId: number, basketId: string, serviceItemId: string, authToken: string, fees: any, paymentType: string) {
    const params = new URLSearchParams();
    params.set('company_id', companyId.toString());
    params.set('service_id', serviceId.toString());
    params.set('basket_id', basketId);
    params.set('service_item_id', serviceItemId);
    params.set('auth_token', authToken);
    params.set('payment_type', paymentType);
    console.log('b2c fees', JSON.stringify(fees));
    params.set('fees', JSON.stringify(fees));
    if (this.dataStore.selectedSuggestion) {
      params.set('suggestion', JSON.stringify(this.dataStore.selectedSuggestion));
    }
    this.currentState = params;

    return this;
  }

  sendToAuth(companyId: number, serviceId: number, basketId: string, serviceItemId: string, authToken: string, fees: any, paymentType: string) {
		this.generateState(
			companyId,
			serviceId,
			basketId,
			serviceItemId,
			authToken,
			fees,
      paymentType
		);
		const state = Buffer.from(this.currentState.toString()).toString('base64');
		console.log('state', state);
		const _url = `${this.host}/oauth2/v2.0/authorize?client_id=${this.clientId}&p=${this.policy}&nonce=${this.nonce}&redirect_uri=https://westminster.ceremonies.registrars.staging.bookinglab.co.uk&scope=openid&response_type=id_token&promt=login&response_mode=query&state=${state}`;
		console.log(`redirecting to ${_url}`);
		window.location.href = `${_url}`;
	}

  getExpiry() : moment.Moment {
    return moment.unix(this.decodedToken.exp).utc().tz('Europe/London');
  }
  getNotBefore() : moment.Moment {
    return moment.unix(this.decodedToken.nbf).utc().tz('Europe/London');
  }
  getIssuedAt() : moment.Moment {
    return moment.unix(this.decodedToken.iat).utc().tz('Europe/London');
  }
  getAuthTime () {
    return moment.unix(this.decodedToken.auth_time).utc().tz('Europe/London');
  }

  isTokenExpired() : boolean {
    console.log(this.decodedToken);
    const exp = moment.unix(this.decodedToken.exp).utc().tz('Europe/London');
    return moment().utc().tz('Europe/London').isSameOrAfter(exp);
  }

  // verifyToken() {
  //   if (this.decodedToken.nonce) {
  //     this.verified = (this.nonce === this.decodedToken.nonce) ? true : false;
  //   }
  //   return this;
  // }

  decodeToken() {
    const decoded = jwtDecode(this.token);
    const _decodedToken:JwtPayload = decoded;
    const finalPayload:ExtendedJwtPayload = JSON.parse(JSON.stringify(_decodedToken));
    this.decodedToken = finalPayload;
    return this;
  }

  async calculateFees() {
    this.dataStore.addFees$.subscribe((feeToAdd) => {
			if (feeToAdd) {
				this.dataStore.serviceFees = this.dataStore.serviceFees.filter(
					(item) => item.questionid !== feeToAdd.questionid
				);
				this.dataStore.serviceFees.push({
					questionid: feeToAdd.questionid,
					item: feeToAdd.item,
					quantity: feeToAdd.quantity,
					cost: feeToAdd.cost,
					deposit: feeToAdd.cost,
				});
				this.calculateTotal();
			}
		});
  }

  async calculate() {
      const slot = await this.availabilityService.getSelectedSlot();
      if (slot) {
        this.date = moment(slot.start).format('YYYY-MM-DD HH:mm:ss');
        this.daysAway = moment(slot.start).diff(moment(), 'd');
      }
  
      if (this.date) {
        let fee: any;
        try {
          this.dataStore.feesUnavailable = false;
          fee = await this.apiService.fees(
            this.company.id,
            this.date,
            this.service.global_id,
            this.service.calculated_duration
          );
        } catch (error) {
          // /fees could not price this ceremony (404 = missing fee row; reason
          // logged by the api service). Unpriced is not free — flag it so the
          // summary refuses checkout instead of charging £0.
          console.error('b2c calculate: unpriced — blocking online checkout', error);
          this.dataStore.feesUnavailable = true;
          this.dataStore.serviceFees = [];
          return;
        }
        this.dataStore.serviceFees = this.dataStore.serviceFees.filter(
          (item) => item.questionid !== fee['questionid']
        );
        // this.dataStore.serviceFees.push({
        //   questionid: fee['questionid'],
        //   item: this.service.name,
        //   quantity: 1,
        //   cost: fee['full_fee'],
        //   deposit: fee['deposit'],
        // });
  
        if (fee.short_notice > 0) {
          if (
            this.service.extra?.hasOwnProperty('fees_extra_item_short_notice_id')
          ) {
            const extraItemShortNoticeId =
              this.service.extra.fees_extra_item_short_notice_id;
            const extraItem: any = await this.apiService.getExtraItem(
              this.company.id,
              this.service.id,
              extraItemShortNoticeId
            );
            this.dataStore.serviceFees.push({
              questionid: 'noid1',
              item: extraItem.item_name,
              quantity: 1,
              cost: extraItem.item_price,
              deposit: extraItem.item_price,
              item_id: extraItemShortNoticeId,
            });
          }
        }
  
        if (fee.out_of_hours > 0) {
          // get the day
          let extraItemOutOfHoursId: any = false;
          const dayOfWeek = moment(this.date).format('ddd');
          if (fee.is_bank_holiday || dayOfWeek === 'Sun') {
            if (
              this.service.extra?.hasOwnProperty(
                'fees_extra_item_out_of_hours_sun_bank_hol_id'
              )
            ) {
              extraItemOutOfHoursId =
                this.service.extra.fees_extra_item_out_of_hours_sun_bank_hol_id;
            }
          } else {
            if (
              this.service.extra?.hasOwnProperty(
                'fees_extra_item_out_of_hours_mon_sat_id'
              )
            ) {
              extraItemOutOfHoursId =
                this.service.extra.fees_extra_item_out_of_hours_mon_sat_id;
            }
          }
          if (extraItemOutOfHoursId) {
            const extraItem: any = await this.apiService.getExtraItem(
              this.company.id,
              this.service.id,
              extraItemOutOfHoursId
            );
            this.dataStore.serviceFees.push({
              questionid: 'noid2',
              item: extraItem.item_name,
              quantity: 1,
              cost: extraItem.item_price,
              deposit: extraItem.item_price,
              item_id: extraItemOutOfHoursId,
            });
          }
        }
      }
      this.calculateTotal();
    }

  calculateTotal() {
		let costTotal = 0;
		let depositTotal = 0;
		costTotal = this.dataStore.serviceFees.reduce(
			(sum, fee) => { console.log('sum', sum, 'fee', fee, 'qty', fee.quantity); return sum + fee.cost * ((fee.quantity) ? fee.quantity : 0)},
			0
		);
    console.log('costTotal',costTotal);
    console.log('this.daysAway', this.daysAway);
		if (this.daysAway > 90) {
      if (this.dataStore.makeItYoursPaymentType === 'deposit') {
        this.totalCost = this.dataStore.serviceFees.reduce(
          (sum, fee) => sum + fee.cost * (fee.quantity ? fee.quantity : 0),
          0
        );
        console.log('fees', this.dataStore.serviceFees);
        depositTotal = 0;
        for (const fee of this.dataStore.serviceFees) {
          if (fee.questionid === "noid2") {
            depositTotal = fee.deposit;
            break;
          }
        }
        console.log('depositTotal', depositTotal);
      }
      else {
        this.totalCost = this.dataStore.serviceFees.reduce(
          (sum, fee) => sum + fee.cost * ((fee.quantity) ? fee.quantity : 0),
          0
        );
        depositTotal = this.dataStore.serviceFees.reduce(
          (sum, fee) => sum + fee.deposit * ((fee.quantity) ? fee.quantity : 0),
          0
        );
      }
		} else {
			this.totalCost = this.dataStore.serviceFees.reduce(
				(sum, fee) => {
         return  sum + fee.cost * ((fee.quantity) ? fee.quantity : 0)
        },
				0
			);
		}
    console.log('this.totalCost', this.totalCost);
		this.dataStore.serviceFees = this.dataStore.serviceFees.sort(
			(a, b) => b.cost - a.cost
		);

    this.dataStore.totalCost = this.totalCost;
		this.costTotal = costTotal;
		this.depositTotal = depositTotal;
    if (this.daysAway > 90) {
      if (this.dataStore.makeItYoursPaymentType === 'deposit') {
        this.dataStore.totalCost = depositTotal;
        this.totalCost = depositTotal;
      }
    }
    console.log('B2c this.dataStore.totalCost', this.totalCost);
	}


} 